export default class RestrictedPositions {
    constructor({ play, gameConfig }) {
        this.play = play;
        this.gameConfig = gameConfig;
    }

    resolve() {
        return [];
    }
}
